export class Switch {
    input: any;
    previousDisplay: any;
    el: any;
    constructor(input: any) {
        if ('checkbox' !== input.type) throw new Error('You can\'t make Switch out of non-checkbox input');

        this.input = input;
        this.previousDisplay = this.input.style.display;
        this.input.style.display = 'none'; // hide the actual input

        this.el = document.createElement('div');
        this.el.className = 'ios-switch';
        this._prepareDOM();

        this.input.parentElement.insertBefore(this.el, this.input);

        // read initial state and set Switch state accordingly
        if (this.input.checked) this.turnOn();

    }

    addClass(el, className) {
        if (el.classList) {
            el.classList.add(className);
        } else {
            el.className += ' ' + className;
        }
    }

    destroy() {
        this.input.style.display = this.previousDisplay;
        this.input.parentElement.remove(this.el);
    }

    removeClass(el, className) {
        if (el.classList) {
            el.classList.remove(className);
        } else {
            el.className = el.className.replace(new RegExp('(^|\\b)' + className.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    hasClass(el, className) {
        if (el.classList) {
            return el.classList.contains(className);
        } else {
            return new RegExp('(^| )' + className + '( |$)', 'gi').test(el.className);
        }
    }

    toggle() {
        if (this.hasClass(this.el, 'on')) {
            this.turnOff();
        } else {
            this.turnOn();
        }

        this.triggerChange();
    }

    turnOn() {
        this.addClass(this.el, 'on');
        this.removeClass(this.el, 'off');
        this.input.checked = true;
    }

    turnOff() {
        this.removeClass(this.el, 'on');
        this.addClass(this.el, 'off');
        this.input.checked = false;
    }

    triggerChange() {
        if ("fireEvent" in this.input) {
            this.input.fireEvent("onchange");
        } else {
            var evt = document.createEvent("HTMLEvents");
            evt.initEvent("change", false, true);
            this.input.dispatchEvent(evt);
        }
    }

    _prepareDOM() {
        var onBackground = document.createElement('div');
        onBackground.className = 'on-background background-fill';

        var stateBackground = document.createElement('div');
        stateBackground.className = 'state-background background-fill';

        var handle = document.createElement('div');
        handle.className = 'handle';

        this.el.appendChild(onBackground);
        this.el.appendChild(stateBackground);
        this.el.appendChild(handle);

    }
}
